import classNames from 'classnames';

import { CoreFullWidthImageData } from 'src/types/components';

import Image from 'components/BaseHelpers/Image';

import styles from './CoreFullWidthImage.module.scss';

export type CoreFullWidthImageProps = CoreFullWidthImageData;

const CoreFullWidthImage = ({ fields }: CoreFullWidthImageProps): JSX.Element | null => {
  const { image, imageAlignment, anchorTag } = fields;

  if (!image) {
    return null;
  }

  return (
    <section id={anchorTag} className={classNames(styles.wrapper, 'spacer', 'spacer--solid')}>
      <div className={classNames(styles.imageWrapper, 'global__wrapper--1920')}>
        <Image
          {...image}
          fill
          className={classNames(styles.image, styles[`image--alignment-${imageAlignment}`])}
        ></Image>
      </div>
    </section>
  );
};

export default CoreFullWidthImage;
